import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import { IProps } from './CancelSubscriptionWithCaptchaModal';

export const renderCancelSubscriptionWithCaptchaModal = (data: IProps) =>
    openPopupHelper({ popupName: popupNames.SUBSCRIPTION_CANCEL_WITH_CAPTCHA, data });
